import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { toHttpParamsObject } from '@capital-access/common/utils';
import { TARGETING_API_BASE_URL } from '../constants';
import { ExcelExportModel } from '../models';
import { TargetingSecurityHoldingsExcelExportRequest } from '../models/targeting-fund-holdings.model';

@Injectable()
export class TargetingExportRepository {
  public getExcelReport(exportRequest: ExcelExportModel, securityId: number): Observable<HttpResponse<Blob>> {
    return this.http.post(`${TARGETING_API_BASE_URL}/export`, exportRequest, {
      responseType: 'blob',
      observe: 'response',
      params: toHttpParamsObject({ securityId })
    });
  }

  exportTargetingSecurityFundHoldings(securityId: number, request: TargetingSecurityHoldingsExcelExportRequest) {
    return this.http
      .post(`${TARGETING_API_BASE_URL}/securities/${securityId}/funds/export`, request, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        map(response => {
          if (response.body === null) {
            throw new Error('SecurityFundHoldingsHistory export returned empty response');
          }
          return response.body;
        })
      );
  }

  constructor(private http: HttpClient) {}
}
